<div class="modal-wrapper" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <div class="modal-content">
        <div class="modal-header">
            <div class="header-container">
                <h2 class="header-fullname">{{ userFullName() ?? 'Activity log details' }}</h2>
                @if (userFullName() && editedDate()) {
                    <div class="header-date">{{ editedDate() }}{{ eventMessage() ? ' - ' + eventMessage() : '' }}</div>
                }
            </div>

            <button class="close-wrapper" (click)="close(undefined)" aria-label="Close modal">
                <div class="icon" [innerHTML]="closeIcon"></div>
            </button>
        </div>

        <div class="modal-body">
            @if (errorMessage()) {
                <p class="modal-error">{{ errorMessage() }}</p>
            } @else {
                <app-client-side-grid
                    [rowData]="changedProps() ?? []"
                    [columnDefs]="columnDefs()"
                    [defaultColDef]="defaultColDef"
                    [domLayout]="'autoHeight'"
                    [suppressHorizontalScroll]="false"
                    [themeConfig]="themeConfig"
                ></app-client-side-grid>
            }
        </div>
    </div>
</div>
